import * as React from 'react';
import IframeResizer from 'iframe-resizer-react';
import style2object from '../utils/style-object';

interface CampfireIframeProps {
  id: string;
  title?: string;
  log?: boolean;
  src?: string;
  style?: string;
}

export default function CampfireIframe(props: CampfireIframeProps) {
  const customStyle = props.style ? style2object(props.style) : {};
  return (
    <IframeResizer
      {...props}
      log={props.log}
      src={props.src}
      style={{ ...customStyle, minWidth: '100%', border: 0 }}
      frameBorder={0}
      id={props.id}
      title={props.title}
    />
  );
}
